import Button from "@/js/common/ui/Button";

interface Props {
  listLine: any[];
  open: boolean;
  onToggle: () => void;
  showOrgInfo?: boolean;  // 소속, 직위 정보 표시 여부
}

const AtrzLineBox = ({ listLine, open, onToggle, showOrgInfo = false }: Props) => {
  const safeArr = (arr: any) => (Array.isArray(arr) ? arr : []);

  return (
    <div className="p10 bd1 bdcDDDDDD bdrd10 bsBdb">
      <div className={`dpFlx aiC jcSb ${open ? "pb10" : ""}`}>
        <div className="fm-b fs14 fc111111">결재 라인</div>

        <Button
          buttonName={open ? "접기" : "펼치기"}
          width={60}
          height={24}
          fontFamily="fm-c"
          fontSize={12}
          letterSpacing={-0.3}
          color="#333"
          backgroundColor="#EDEDED"
          borderRadius={8}
          buttonClass="dpFlx aiC jcC bd1 bdc878787"
          onClickFunc={onToggle}
        />
      </div>

      {!open ? null : safeArr(listLine).length === 0 ? (
        <div className="p10 taC fm-c fs13 fc666666">
          결재 라인 정보가 없습니다.
        </div>
      ) : (
        <div className="bd1 bdcEDEDED bdrd8 ofH bgcWhite">
          <div className="dpFlx h30 bgcF6F6F6 bdb1 bdcEDEDED">
            <div className="w40 dpFlx aiC jcC fm-c fs13 fc555555">단계</div>

            {showOrgInfo && (
              <>
                <div className="w120 dpFlx aiC jcC fm-c fs13 fc555555">소속</div>
                <div className="w100 dpFlx aiC jcC fm-c fs13 fc555555">직위</div>
              </>
            )}

            <div className="flx1 dpFlx aiC jcC fm-c fs13 fc555555">결재자</div>
            <div className="w60 dpFlx aiC jcC fm-c fs13 fc555555">상태</div>
            <div className="w130 dpFlx aiC jcC fm-c fs13 fc555555">결재일시</div>
          </div>

          {safeArr(listLine).map((x: any, i: number) => (
            <div
              key={`${String(x.atrzSeq ?? i + 1)}-${i}`}
              className="dpFlx h30 bdb1 bdcEDEDED"
            >
              <div className="w40 dpFlx aiC jcC fm-c fs12 fc333333">
                {String(x.atrzSeq ?? i + 1)}
              </div>

              {showOrgInfo && (
                <>
                  <div className="w120 dpFlx aiC jcC fm-c fs12 fc333333">
                    {String(x.APLY_ORG_NM ?? x.aplyOrgNm ?? "")}
                  </div>

                  <div className="w100 dpFlx aiC jcC fm-c fs12 fc333333">
                    {String(x.JBPS_SE_NM ?? x.jbpsSeNm ?? "")}
                  </div>
                </>
              )}

              <div className="flx1 dpFlx aiC jcC fm-c fs12 fc333333">
                {String(x.aprvrNm ?? x.userNm ?? "")}
              </div>

              <div className="w60 dpFlx aiC jcC fm-c fs12 fc333333">
                {String(x.atrzPrgrsSttsNm ?? "")}
              </div>

              <div className="w130 dpFlx aiC jcC fm-c fs12 fc333333">
                {String(x.atrzDt ?? "")}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AtrzLineBox;